module.exports = __webpack_public_path__ + "img/csgs2.14cc3e1a.png";